import { render } from "./PokeWordle.vue?vue&type=template&id=e7bd8de4&scoped=true"
import script from "./PokeWordle.vue?vue&type=script&lang=js"
export * from "./PokeWordle.vue?vue&type=script&lang=js"

import "./PokeWordle.vue?vue&type=style&index=0&id=e7bd8de4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7bd8de4"]])

export default __exports__